import store from '../store';
import Emitter from './Emitter';
import VirtualScroll from './VirtualScroll';
import { Sniffer, bounds } from '../utils/index';

export default class Scroll {
  constructor(obj) {
    this.isSmooth = obj.isSmooth || false;

    if (this.isSmooth) {
      document.body.classList.add('is-smooth');
    }

    this.on();
  }

  setScrollBounds() {
    const { page, currentPage } = store;
    const { vh } = page;
    const height = bounds(currentPage).height;
    Object.assign(store.page, { fh: height > vh ? height - vh : 0 });
  }

  onEvent = (e) => {
    Emitter.emit('scroll', { y: e.deltaY * -1 });
  };

  onScroll = () => {
    Emitter.emit('scroll', { y: window.scrollY });
  };

  on() {
    this.l('add');
  }

  off() {
    this.l('remove');
  }

  l(a) {
    if (this.isSmooth) {
      const vs = new VirtualScroll({
        mouseMultiplier: Sniffer.sniff.isWindows ? 1.1 : 0.45,
        touchMultiplier: 3.5,
        firefoxMultiplier: Sniffer.sniff.isWindows ? 40 : 90,
        passive: true,
      });

      vs['on'](this.onEvent);
    } else {
      document.addEventListener('scroll', this.onScroll, true);
    }
  }
}
